module.exports = __webpack_public_path__ + "img/Mask.7eeb79be.png";